<template>
  <div class="check-panel">
    <p
      v-if="showTitle"
      class="q"
    >
      <slot name="title"></slot>
    </p>
    <div class="buttons">
      <slot name="buttons"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CheckPanel',
  computed: {
    showTitle () {
      return !!this.$slots.title
    }
  }
}
</script>

<style lang="scss" scoped>
.check-panel {
  margin-top: 30px;
  background-color: white;
  border-radius: 10px;
  text-align: center;
  padding: 7px 20px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
}

.q {
  font-weight: $fw-semi;
  font-size: $fs-normal;
  line-height: $lh-heading;
  color: $c-dark;
  margin-top: 10px;
  margin-bottom: 0.5em;
}

.buttons {
  @extend %clearfix;
}
</style>
